module.exports = __webpack_public_path__ + "img/梅竹_圈-素材.25f37554.svg";